import { useTranslation } from '@thoughtspot/i18n';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
export const DropDownFormComponent = ({ label, values, elementKey, defaultValue, selectedValue, onChange, isDisabled = false, }) => {
    const { t } = useTranslation();
    const onChangeDropDown = (data) => {
        onChange(elementKey, data.id);
    };
    const optionGroup = [
        {
            options: values.map(value => {
                let displayValue = '';
                let key = '';
                if (typeof value === 'string') {
                    displayValue = value;
                    key = value;
                }
                else if (typeof value === 'object') {
                    displayValue = value.valueTranslation
                        ? t(value.valueTranslation)
                        : value.value;
                    key = value.value;
                }
                return {
                    id: key,
                    label: displayValue,
                };
            }),
        },
    ];
    let selectedVal = selectedValue;
    if (!selectedVal && typeof defaultValue === 'string') {
        selectedVal = defaultValue;
    }
    else if (!selectedVal && typeof defaultValue === 'object') {
        selectedVal = defaultValue.value;
    }
    return (React.createElement(FormControl, { label: label, className: styles.formComponentItem, noMarginBottom: true, "data-testid": `test-id-${elementKey}` },
        React.createElement(Select.Dropdown, { key: elementKey, optionsGroups: optionGroup, selectedOptions: [selectedVal], onChange: onChangeDropDown, "data-testid": "select-dropdown-form-component", disabled: isDisabled })));
};
//# sourceMappingURL=drop-down-form.component.js.map